import React, { useEffect, useState } from "react";
import Auth from "src/auth";
//import { useHistory } from "react-router-dom";
import { apiCall, apiCallSPPost } from "src/_apiConfig/apiCall";
import { CBadge, CButton, CCol, CRow } from "@coreui/react";
import CommonList from "src/views/common/CommonList";
import TableButtonAnchor from "src/views/common/Table/TableButtonAnchor";
import ModalPaymentTransactionHistory from "./ModalPaymentTransactionHistory";

const LotListViewAdHocPayment = (props) => {
  //let history = useHistory();
  const { authenticated } = Auth();
  const userRole = authenticated.role;
  const [ahpListData, setAHPFEListData] = useState([]); // List data manage
  const [paymentTransactionHistory, setpaymentTransactionHistory] = useState(
    []
  );
  const [popupGRFEId, setpopupGRFEId] = useState(0);
  const [showpaymentHistory, setshowpaymentHistory] = useState(false);

  useEffect(() => {
    if (props.viewListDetails.isAdHocPayment === true) {
      getLotAdHocPayment(
        parseInt(props.viewListDetails.lotId),
        parseInt(props.viewListDetails.userId)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.viewListDetails.isAdHocPayment]);

  const getLotAdHocPayment = async (id, bidder_id) => {
    //if (authenticated) {

    const data = JSON.stringify({
      lot_id: id,
      bidder_id: bidder_id,
    });
    await apiCallSPPost(`LotAdHocPayment/ByLotIdAndBidderId`, data, []).then(
      (res) => {
        if (res.success) {
          console.log("getRoleDetails", res.data);
          //setViewLotLeftRequestDetails([res.data]);
          setAHPFEListData(res.data);
          //setViewLLRPayment(res.data?.paymentDescription);
        }
      }
    );
    // }
  };
  const payAdHocPayment = async (amount, ahpid) => {
    console.log("payAdHocPayment : ", amount, ahpid);
    props.ConfirmationPopupHandler(
      9,
      1,
      "Are you sure you want to proceed for Payment?",
      amount,
      props.viewListDetails.lotId,
      0,
      0,
      0, //props.viewListDetails.godownRentLateFee,
      0,
      0,
      0,
      0,
      0,
      "",
      ahpid
    );
  };

  const ViewBankTransaction = async (lotId, paymentType, grfeId) => {
    props.setIdForPaymentHistory(lotId);
    props.setTypeForPaymentHistory(paymentType);
    setpopupGRFEId(grfeId);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "PaymentHistory/GetPaymentHistory",
      "POST",
      header,
      JSON.stringify({
        LotId: lotId,
        PaymentType: paymentType,
        otherId: grfeId,
      })
    );

    const jsonobj = await response.json();
    if (response.status === 200) {
      setpaymentTransactionHistory(jsonobj);
    } else {
      setpaymentTransactionHistory([]);
    }

    setshowpaymentHistory(true);
  };
  const getPaymentTypeValue = (id) => {
    switch (id) {
      case 1:
        return "Payment Collected without GST";
      case 2:
        return "Payment Collected with GST";
      case 3:
        return "Only Collected GST";
      default:
        return "";
    }
  };

  let scopedSlotsGodownRentList = {
    paymentTypeValue: (item, index) => {
      return (
        <td className="py-2">
          <span>{getPaymentTypeValue(item.paymentTypeId)}</span>
        </td>
      );
    },
    viewDocument: (item, index) => {
      return (
        <TableButtonAnchor
          fileName={item.supportFilePath}
          path={item.filePathUrl}
          buttonName={"View"}
        />
      );
    },
    PaymentStatus: (item, index) => {
      return (
        <td className="py-2">
          {item.adHocPayment_Status === "Paid" ? (
            <CBadge color="success" className="mfs-auto badgeFont100">
              {item.adHocPayment_Status}
            </CBadge>
          ) : item.adHocPayment_Status === "Pending" ? (
            <CBadge color="warning" className="mfs-auto badgeFont100">
              {item.adHocPayment_Status}
            </CBadge>
          ) : (
            <CBadge color="danger" className="mfs-auto badgeFont100">
              {item.adHocPayment_Status}
            </CBadge>
          )}
        </td>
      );
    },
  };
  const fieldsAdHocPayment = [
    {
      key: "paymentTypeValue",
      label: "Payment Type",
    },

    {
      key: "dueDate",
      label: "Due Date",
    },

    {
      key: "amount",
      label: "Amount",
    },

    {
      key: "cgstAmount",
      label: "CGST",
      sorter: false,
      filter: false,
    },
    {
      key: "sgstAmount",
      label: "SGST",
      sorter: false,
      filter: false,
    },
    {
      key: "igstAmount",
      label: "IGST",
      sorter: false,
      filter: false,
    },
    {
      key: "title_Purpose",
      label: "Title/Purpose",
    },
    {
      key: "insertedComment",
      label: "Comment",
    },

    {
      key: "viewDocument",
      label: "Document",
    },
    {
      key: "PaymentStatus",
      label: "Status",
      sorter: false,
      filter: false,
    },
    // {
    //   key: "paymentdateformat",
    //   label: "Payment Date",
    // },
    // {
    //   key: "action",
    //   label: "",
    // },
  ];
  return (
    props.viewListDetails.isAdHocPayment === true && (
      <div key="divsLotAdHocPayment">
        <ModalPaymentTransactionHistory
          key={"paymentTransactionHistory"}
          setshowpaymentHistory={setshowpaymentHistory}
          showpaymentHistory={showpaymentHistory}
          paymentTransactionHistory={paymentTransactionHistory}
          LotId={props.viewListDetails.lotId}
          paymentType={"AHP"}
          grfeId={popupGRFEId}
          setpaymentTransactionHistory={setpaymentTransactionHistory}
        />
        <CRow className="pt-3 mt-3">
          <CCol className="mb-2" xl={12}>
            <h3 className="titlehr">Adjustment Payment </h3>
          </CCol>
        </CRow>
        {ahpListData?.map((item, index) => (
          <div className="mb-2">
            <div className="viewTable pl-1 pr-1">
              {item && (
                <CommonList
                  key={"List_" + index}
                  listName=""
                  items={[item]}
                  fields={fieldsAdHocPayment}
                  loading={false}
                  disabledprev={true}
                  disablednext={true}
                  displayPaggingButton={false}
                  scopedSlots={scopedSlotsGodownRentList}
                />
              )}
            </div>
            <CRow className="pl-2 pr-1" key={"Update_" + index}>
              <CCol className="mb-2 " xl={12}>
                <CRow className={"mt-2"}>
                  {userRole === "Bidder" &&
                  item.adHocPayment_Status !== "Paid" &&
                  item.isAdHocPaymentPaidAllow === true ? (
                    <CButton
                      color="info"
                      className="ml-2 mt-1"
                      onClick={() =>
                        payAdHocPayment(
                          item?.adHocPayment_Paid,
                          item.adHocPaymentId
                        )
                      }
                    >
                      Pay Now = {item?.adHocPayment_Paid}
                    </CButton>
                  ) : (
                    ""
                  )}
                  {item.isPaymentHistory === true &&
                    item.adHocPayment_Status !== "Paid" && (
                      <CButton
                        color="info"
                        className="ml-2 mt-1"
                        style={{ height: "35px" }}
                        onClick={() =>
                          ViewBankTransaction(
                            props.viewListDetails.lotId,
                            "AHP",
                            item.adHocPaymentId
                          )
                        }
                      >
                        History
                      </CButton>
                    )}
                  {item.adHocPayment_Status !== "Paid" &&
                    item.isAdHocPaymentDueDateIsOver === true && (
                      <CCol className={"font-weight-bold"}>
                        Payment Due Date is Over.
                      </CCol>
                    )}
                  {item.isAdHocPaymentPaid === true &&
                    item.adHocPayment_Status === "Paid" && (
                      // && authenticated.role === "Bidder"
                      <>
                        <CCol
                          className="payment-label col-9"
                          dangerouslySetInnerHTML={{
                            __html: item.adHocPayment_PaidDescription,
                          }}
                        ></CCol>

                        <CButton
                          color="info"
                          className="ml-2 mt-1"
                          style={{ height: "35px" }}
                          onClick={() =>
                            ViewBankTransaction(
                              props.viewListDetails.lotId,
                              "AHP",
                              item.adHocPaymentId
                            )
                          }
                        >
                          History
                        </CButton>

                        <CButton
                          color="info"
                          className="ml-2 mt-1"
                          style={{ height: "35px" }}
                          onClick={() =>
                            props.PaymentStatusViewHanlder(
                              item.adHocPayment_PaymentTranId
                            )
                          }
                        >
                          Receipt
                        </CButton>
                      </>
                    )}
                </CRow>
              </CCol>
            </CRow>
            <hr className="ml-2 ml-2" />
          </div>
        ))}
      </div>
    )
  );
};

export default LotListViewAdHocPayment;
